import React from 'react';
import PropTypes from 'prop-types';
import { 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow 
} from '@mui/material';


const EnergyReimbursement = ({data}) => {

  let {
    nightSupplyTariff,
    daySupplyTariff,
    reportedDayAcKwh,
    reportedNightAcKwh,
    reportedDayDcKwh,
    reportedNightDcKwh,
    acReimbursementDay,
    acReimbursementNight,
    dcReimbursementDay,
    dcReimbursementNight,
  } = data;

  nightSupplyTariff = nightSupplyTariff ?? 0;
  daySupplyTariff = daySupplyTariff ?? 0;
  reportedDayAcKwh = reportedDayAcKwh ?? 0;
  reportedNightAcKwh = reportedNightAcKwh ?? 0;
  reportedDayDcKwh = reportedDayDcKwh ?? 0;
  reportedNightDcKwh = reportedNightDcKwh ?? 0;
  acReimbursementDay = acReimbursementDay ?? 0;
  acReimbursementNight = acReimbursementNight ?? 0;
  dcReimbursementDay = dcReimbursementDay ?? 0;
  dcReimbursementNight = dcReimbursementNight ?? 0;

  return (
    <div className="mb-6">
      <h3 className="text-[16px] font-semibold mb-2">Energy Reimbursement</h3>
      <TableContainer>
        <Table 
          aria-label="Energy Reimbursement" 
          sx={{
            borderCollapse: 'separate',
            borderRadius: '15px',
            border: '1px solid rgb(224, 224, 224)',
          }}>
          <TableHead>
            <TableRow>
            <TableCell sx={{fontWeight: 'bold'}}>AC</TableCell>
              <TableCell sx={{fontWeight: 'bold'}}>kWh Used</TableCell>
              <TableCell sx={{fontWeight: 'bold'}}>Cost per kWh</TableCell>
              <TableCell align="right" sx={{fontWeight: 'bold'}}>Total</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>Reimbursement of electricity used (Day)</TableCell>
              <TableCell>{`${reportedDayAcKwh} kWh`}</TableCell>
              <TableCell>{`£${daySupplyTariff / 100}`}</TableCell>
              <TableCell align="right">{`£${acReimbursementDay.toFixed(2)}`}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Reimbursement of electricity used (Night)</TableCell>
              <TableCell>{`${reportedNightAcKwh} kWh`}</TableCell>
              <TableCell>{`£${nightSupplyTariff / 100}`}</TableCell>
              <TableCell align="right">{`£${acReimbursementNight.toFixed(2)}`}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <TableContainer>
        <Table 
          aria-label="Energy Reimbursement" 
          sx={{
            borderCollapse: 'separate',
            borderRadius: '15px',
            border: '1px solid rgb(224, 224, 224)',
          }}>
          <TableHead>
            <TableRow>
            <TableCell sx={{fontWeight: 'bold'}}>DC</TableCell>
              <TableCell sx={{fontWeight: 'bold'}}>kWh Used</TableCell>
              <TableCell sx={{fontWeight: 'bold'}}>Cost per kWh</TableCell>
              <TableCell align="right" sx={{fontWeight: 'bold'}}>Total</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>Reimbursement of electricity used (Day)</TableCell>
              <TableCell>{`${reportedDayDcKwh} kWh`}</TableCell>
              <TableCell>{`£${daySupplyTariff / 100}`}</TableCell>
              <TableCell align="right">{`£${dcReimbursementDay.toFixed(2)}`}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Reimbursement of electricity used (Night)</TableCell>
              <TableCell>{`${reportedNightDcKwh} kWh`}</TableCell>
              <TableCell>{`£${nightSupplyTariff / 100}`}</TableCell>
              <TableCell align="right">{`£${dcReimbursementNight.toFixed(2)}`}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

export default EnergyReimbursement;

EnergyReimbursement.propTypes = {
  data: PropTypes.object.isRequired,
};